import React, { useCallback, useEffect, useState } from 'react';
import {
  Button,
  Modal,
  Row,
  Space,
  Typography,
  Form,
  Tabs,
  Card,
  Input,
  Table,
  message,
  Col,
  Select,
  Divider
} from 'antd';
import { leaveEditForm } from 'utils';
import { FormLabel } from 'components/common';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import moment from 'moment';

const { Text } = Typography;
type Props = {
  onHide: () => void;
  onSubmit: (
    items: any[],
    data: any[],
    str: string,
    tab: string
  ) => void;
  defaultData: string[];
  defaultStr: string;
  skuList: {id: string, sku: string, upc: string, lotNumber: string, uom: string, fulfillmentReturnLineNum: number}[];
  defaultTab: string;
  uomEnable: boolean;
  lotEnable: boolean;
};
interface Item {
  id: number | string;
  qty: number;
  [key: string]: any; // 支持任意其他属性
}
function mergeArrayWithCustomMerge(arr: Item[]): Item[] {
  const merged = arr.reduce((acc: { [key: string]: Item }, current: Item) => {
    const id = current.id.toString();
    
    if (acc[id]) {
      acc[id] = {
        ...acc[id],
        ...current,
        qty: acc[id].qty + current.qty,
      };
    } else {
      acc[id] = { ...current };
    }
    
    return acc;
  }, {});

  return Object.values(merged);
}

// eslint-disable-next-line
export default (props: Props) => {
  const { onHide, onSubmit, defaultData, skuList, defaultStr, defaultTab, uomEnable, lotEnable } =
    props;
  const [selectedTab, setSelectTab] = useState<string>(defaultTab);
  const [data, setData] = useState<any[]>(defaultData);
  const [data2, setData2] = useState<any[]>([]);
  const [str, setStr] = useState(defaultStr);
  const [lastScan, setLastScan] = useState<{
    sku: string;
    time: string;
  }>();
  const [showSelectLotUom, setShowSelectLotUom] = useState(false);
  const [currentLotUomList, setCurrentLotUomList] = useState<any[]>([]);
  const [selectedLineNum, setSelectedLineNum] = useState<any>()
  const [form] = Form.useForm();

  const checkStr = useCallback((str: string) => {
    const temp = str.split('\n');
    const tempArr: any[] = [];
    let arr: string[] = [];
    temp.map((i) => {
      if (i) {
        const t = i.replaceAll('\t', '#__#')
        const kArr = i.split('\t')
        let sku: string = '';
        let lotNumber: string = '';
        let uom: string = '';
        if(lotEnable){
          if(uomEnable){
            sku = kArr[0]
            lotNumber = kArr[1] || ''
            uom = kArr[2] || ''
          } else {
            sku = kArr[0]
            lotNumber = kArr[1] || ''
          }
        } else {
          if(uomEnable){
            sku = kArr[0]
            uom = kArr[1] || ''
          } else {
            sku = kArr[0]
          }
        }

        const idx = arr.indexOf(i)
        if (idx === -1) {
          arr.push(i);
          tempArr.push({
            id: t,
            sku: sku,
            lotNumber: lotNumber,
            uom: uom,
            qty: 1,
          });
        } else {
          tempArr[idx] = {
            ...tempArr[idx],
            qty: tempArr[idx].qty + 1,
          };
        }
        return true;
      } else {
        return true;
      }
    });
    setData2(tempArr);
    return tempArr;
  }, [uomEnable, lotEnable]);
  /**
   * handle submit event
   */
  const handleSubmit = useCallback(async () => {
    if (selectedTab === 'single') {
      onSubmit(data, data, str, selectedTab);
    } else {
      const t = checkStr(str);
      const tempT = mergeArrayWithCustomMerge(t)
      onSubmit(tempT, data, str, selectedTab);

    }
  }, [onSubmit, data, str, selectedTab, checkStr]);
  /**
   * handle cancel event
   */
  const handleCancel = useCallback(async () => {
    const cancel = await leaveEditForm({}, form);
    if (cancel) {
      onHide();
    }
  }, [onHide, form]);

  useEffect(() => {
    if (defaultStr) {
      checkStr(defaultStr);
    }
  }, [defaultStr, checkStr]);

  const onKeyDown = (evt: any) => {
    if ([9, 13].indexOf(evt.keyCode) > -1) {
      form.setFieldsValue({
        scanValue: undefined,
      });
      evt.preventDefault();
      if (evt.target.value) {
        const tempArr = skuList.filter(i => i.sku === evt.target.value || i.upc === evt.target.value)
        if(tempArr.length !== 0) {
          if(tempArr.length > 1 ){
            setCurrentLotUomList(tempArr)
            setShowSelectLotUom(true)
          } else {
            const idx = data.findIndex(i=> i.id === tempArr[0].id)
            if(idx > -1) {
              const temp = [...data];
              temp[idx] = {
                ...temp[idx],
                qty: temp[idx].qty + 1,
              }
              setData([...temp]);
            } else {
              setData([
                {
                  ...tempArr[0],
                  qty: 1,
                },
                ...data,
              ]);
            }
          }
          setLastScan({
            sku: evt.target.value,
            time: moment().format('hh:mm:ssA'),
          });
        } else {
          message.error(`[${evt.target.value}] not found`);
        }

      }
    }
  };

    const checkLine = useCallback((item:any, record:any)=>{
      if(uomEnable && lotEnable) {
        return item.sku === record.sku && item.lotNumber === record.lotNumber && item.uom === record.uom 
      }
      if(uomEnable && !lotEnable) {
        return item.sku === record.sku && item.uom === record.uom 
      }
      if(!uomEnable && lotEnable) {
        return item.sku === record.sku && item.lotNumber === record.lotNumber
      }
      return false;
    },[uomEnable, lotEnable])

    const checkLine2 = useCallback((item:any, record:any)=>{
      if(uomEnable && lotEnable) {
        return (item.sku === record.sku || item.upc === record.upc) && item.lotNumber === record.lotNumber && item.uom === record.uom 
      }
      if(uomEnable && !lotEnable) {
        return (item.sku === record.sku || item.upc === record.upc) && item.uom === record.uom 
      }
      if(!uomEnable && lotEnable) {
        return (item.sku === record.sku || item.upc === record.upc) && item.lotNumber === record.lotNumber
      }
      return false;
    },[uomEnable, lotEnable])

  const getColumns1 = useCallback(()=>{
    const cls: ColumnsType<any> = [
      {
        title: 'SKU',
        dataIndex: 'sku',
        key: 'sku',
        render: (text, record) =>
          skuList.findIndex( i => checkLine(i,record)) > -1 ? (
            <Text>{text}</Text>
          ) : (
            <Text style={{color: '#ff4d4f'}} delete>{text}</Text>
          ),
      },
      {
        title: 'UPC',
        dataIndex: 'upc',
        key: 'upc',
        render: (text, record) =>
        skuList.findIndex( i => checkLine(i,record)) > -1 ? (
          <Text>{text}</Text>
          ) : (
            <Text style={{color: '#ff4d4f'}} delete>{text}</Text>
          ),
      },
      {
        title: 'LOT #',
        dataIndex: 'lotNumber',
        key: 'lotNumber',
        render: (text, record) =>
        skuList.findIndex( i => checkLine(i,record)) > -1 ? (
          <Text>{text}</Text>
          ) : (
            <Text style={{color: '#ff4d4f'}} delete>{text}</Text>
          ),
      },
      {
        title: 'UOM',
        dataIndex: 'uom',
        key: 'uom',
        render: (text, record) =>
        skuList.findIndex( i => checkLine(i,record)) > -1 ? (
          <Text>{text}</Text>
          ) : (
            <Text style={{color: '#ff4d4f'}} delete>{text}</Text>
          ),
      },
      {
        title: 'Qty',
        dataIndex: 'qty',
        key: 'qty',
        render: (text, record) =>
        skuList.findIndex( i => checkLine(i,record)) > -1 ? (
          <Text>{text}</Text>
        ) : (
          <Text style={{color: '#ff4d4f'}} delete>{text}</Text>
        ),
      },
    ];
    let temp  = [...cls]
    temp = uomEnable ? [...temp] : temp.filter(i=> i.key !== 'uom')
    temp = lotEnable ? [...temp] : temp.filter(i=> i.key !== 'lotNumber')
    return [...temp]
  },[uomEnable, lotEnable, checkLine, skuList])

  const getColumns2 = useCallback(()=>{
    const cls: ColumnsType<any> = [
      {
        title: 'SKU',
        dataIndex: 'sku',
        key: 'sku',
        render: (text, record) =>
          skuList.findIndex( i => checkLine2(i,record)) > -1 ? (
            <Text>{text}</Text>
          ) : (
            <Text style={{color: '#ff4d4f'}} delete>{text}</Text>
          ),
      },
      {
        title: 'LOT #',
        dataIndex: 'lotNumber',
        key: 'lotNumber',
        render: (text, record) =>
          skuList.findIndex( i => checkLine2(i,record)) > -1 ? (
            <Text>{text}</Text>
          ) : (
            <Text style={{color: '#ff4d4f'}} delete>{text}</Text>
          ),
      },
      {
        title: 'UOM',
        dataIndex: 'uom',
        key: 'uom',
        render: (text, record) =>
          skuList.findIndex( i => checkLine2(i,record)) > -1 ? (
            <Text>{text}</Text>
          ) : (
            <Text style={{color: '#ff4d4f'}} delete>{text}</Text>
          ),
      },
      {
        title: 'Qty',
        dataIndex: 'qty',
        key: 'qty',
        render: (text, record) =>
        skuList.findIndex( i => checkLine2(i,record)) > -1 ? (
          <Text>{text}</Text>
        ) : (
          <Text style={{color: '#ff4d4f'}} delete>{text}</Text>
        ),
      },
    ];
    let temp  = [...cls]
    temp = uomEnable ? [...temp] : temp.filter(i=> i.key !== 'uom')
    temp = lotEnable ? [...temp] : temp.filter(i=> i.key !== 'lotNumber')
    return [...temp]
  },[uomEnable, lotEnable, checkLine2, skuList])





  return (
    <Modal
      title="Scan to Recieve"
      centered
      visible={true}
      width={800}
      destroyOnClose={true}
      onCancel={handleCancel}
      footer={
        <Row justify="end">
          <Space>
            <Button
              key="submit"
              type="primary"
              onClick={handleSubmit}
              icon={<CheckOutlined />}
            >
              Continue
            </Button>
            <Button onClick={handleCancel} icon={<CloseOutlined />}>
              Cancel
            </Button>
          </Space>
        </Row>
      }
    >
      <Form form={form}>
        <Tabs activeKey={selectedTab} onChange={setSelectTab}>
          <Tabs.TabPane tab="Single Scan" key="single">
            <Card
              title={
                <Row justify="space-between">
                  <Space>
                    <FormLabel>Scan SKU / UPC</FormLabel>
                    <Form.Item noStyle name="scanValue">
                      <Input
                        allowClear
                        style={{ width: 200 }}
                        autoFocus
                        onKeyDown={onKeyDown}
                      />
                    </Form.Item>
                  </Space>
                  {lastScan && (
                    <Row>
                      <Space>
                        <Typography.Text
                          style={{ fontSize: 12 }}
                          type="secondary"
                        >{`Last scan: ${lastScan.sku}`}</Typography.Text>
                        <Typography.Text
                          style={{ fontSize: 12 }}
                          type="secondary"
                        >{`Scanned time: ${lastScan.time}`}</Typography.Text>
                      </Space>
                    </Row>
                  )}
                </Row>
              }
            >
              <Table
                rowKey="sku"
                scroll={{ y: 240 }}
                dataSource={data}
                columns={getColumns1()}
                pagination={false}
              />
            </Card>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Paste Multiple" key="multiple">
            <Row>
              <Col span={12}>
              <Space direction="vertical">
              <Row>
                  <Space split={<Divider type="vertical" />}>
                    <Typography.Text>SKU</Typography.Text>
                    {lotEnable && <Typography.Text>LOT#</Typography.Text>}
                    {uomEnable && <Typography.Text>UOM</Typography.Text>}
                  </Space>
                </Row>
                  <Input.TextArea
                    style={{ width: 350 }}
                    rows={16}
                    value={str}
                    onChange={(e) => setStr(e.target.value)}
                  />
                  <Button
                    onClick={() => {
                      checkStr(str);
                    }}
                  >
                    Check
                  </Button>
                </Space>
              </Col>
              <Col span={12}>
              <Table
                rowKey="sku"
                scroll={{ y: 322 }}
                dataSource={data2}
                columns={getColumns2()}
                pagination={false}
              />
              </Col>
            </Row>
          </Tabs.TabPane>
        </Tabs>
      </Form>
      {currentLotUomList.length > 0 && showSelectLotUom && (
          <Modal
            title="Select LOT# & UOM"
            closable={false}
            maskClosable={false}
            okText="Select"
            okType="primary"
            visible
            cancelButtonProps={{hidden: true}}
            cancelText=""
            onOk={() => {
              setShowSelectLotUom(false);
              setCurrentLotUomList([]);
              const selected = skuList.filter(
                (i: any) => i.fulfillmentReturnLineNum === selectedLineNum
              );

              const idx = data.findIndex(i => i.fulfillmentReturnLineNum === selected[0].fulfillmentReturnLineNum)
              if(idx > -1) {
                const temp = [...data]
                temp[idx] = {
                  fulfillmentReturnLineNum: temp[idx].fulfillmentReturnLineNum,
                  sku: temp[idx].sku,
                  upc: temp[idx].upc,
                  lotNumber: temp[idx].lotNUmber,
                  uom: temp[idx].uom,
                  qty: temp[idx].qty + 1,
                }
              } else {
                setData([
                  {
                    fulfillmentReturnLineNum: selected[0].fulfillmentReturnLineNum,
                    sku: selected[0].sku,
                    upc: selected[0].upc,
                    lotNumber: selected[0].lotNumber,
                    uom: selected[0].uom,
                    qty: 1,
                  },
                  ...data,
                ]);
              }

              
              
            }} 
          >
            <Form>
              <Form.Item label={<FormLabel>{`[LOT #] (UOM)`}</FormLabel>}>
                <Select onChange={setSelectedLineNum} value={selectedLineNum}>
                  {
                    currentLotUomList.map(i=><Select.Option key={i.fulfillmentReturnLineNum} value={i.fulfillmentReturnLineNum}>{`[${i.lotNum || ' '}] (${i.uom})`}</Select.Option>)
                  }
                </Select>
              </Form.Item>
            </Form>
          </Modal>
        )}
    </Modal>
  );
};
